import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import { LogoutProvider } from '../logout-provider'
import { AccountSubscriptionProvider } from '../account-subscription-provider'
import { useServerHealthCheck } from 'src/hooks'
import usePersistRoute from 'src/hooks/common/use-presist-route.hook'
import { ROUTES } from 'src/constants'
import useIntercom from 'src/hooks/common/use-intercom.hook'

const RouterWrapper = () => {
  const navigate = useNavigate()
  const { data, error, isLoading } = useServerHealthCheck()

  usePersistRoute()
  useIntercom()

  useEffect(() => {
    if (!isLoading && (error || data !== 'OK')) {
      return navigate(ROUTES.MAINTENANCE, { replace: true })
    }
  }, [isLoading, error, data])

  return (
    <AccountSubscriptionProvider>
      <LogoutProvider>
        <Outlet />
      </LogoutProvider>
    </AccountSubscriptionProvider>
  )
}

export { RouterWrapper }
